// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '80'
  }, {
    prop: 'icon',
    label: '',
    // Object: 'value',
    img: true,
    width: '180'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'name_en',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'updated_at',
    label: '',
    Object: 'value',
    width: '180'
  }]
}
